import { zetApi } from '@zet/network'
import { HDFC_ASKCODES } from '@zet/utils/Constants'

import { LeadCrossSelling, LeadProgress } from './types'

export async function getLeadDetails(leadId: number) {
  const { data } = await zetApi.get<LeadProgress>(
    `leadDetails?leadId=${leadId}`
  )

  return data?.data[0]
}

export async function getLeadsTransactionHistory({
  leadId,
  pageParam,
  limit,
}: {
  leadId: number
  pageParam: number
  limit: number
}) {
  const { data } = await zetApi.get('/lead-transactions-history', {
    params: {
      leadId,
      page: pageParam,
      limit,
    },
  })
  return data?.data
}

export async function getCrossSelling({
  leadId,
  pageParam,
  limit,
}: {
  leadId: number
  pageParam: number
  limit: number
}) {
  const { data } = await zetApi.get<LeadCrossSelling>(
    `leads/v2/cross-selling/recommendations`,
    {
      params: {
        leadId,
        page: pageParam,
        limit,
      },
    }
  )
  return data?.data
}

export const submitArn = (props: {
  userFormId: string
  referenceId: string
}) => {
  return zetApi.post(`/userForm/ask/submit`, {
    userFormId: String(props?.userFormId),
    askCode: HDFC_ASKCODES.$ARN_PENDING,
    payload: {
      referenceId: props?.referenceId,
    },
  })
}
